function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from "react";
import styled, { css } from "styled-components";
import usePochtaTheme from "../core/hooks/usePochtaTheme";
import { display, flexbox, fontVariant, margins, paddingBottom, paddings, paddingTop, sizes, text, composeEnhancers } from "../core/enhancers";

var H = function H(_ref) {
  var variantProperty = _ref.variant,
      className = _ref.className,
      children = _ref.children;
  var defaultVariant = usePochtaTheme().componentsTokens.header.defaultVariant;
  var variant = variantProperty || defaultVariant;

  if (variant === "h0") {
    variant = "h1";
  }

  return /*#__PURE__*/React.createElement(variant, {
    className: className
  }, children);
};

var composedEnhancer = composeEnhancers(fontVariant, paddingBottom, paddingTop);
var Header = styled(H).withConfig({
  displayName: "Header",
  componentId: "sc-41mdkh-0"
})(["", " margin:0;", ";", ";", ";", ";", ";&&{", ";}"], function (_ref2) {
  var theme = _ref2.theme,
      withPaddingTop = _ref2.withPaddingTop,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? theme.componentsTokens.header.defaultVariant : _ref2$variant;
  var config = theme.componentsTokens.header.variants[variant];

  if (!config) {
    throw new TypeError("\u041A\u043B\u044E\u0447 ".concat(variant, " \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0442\u0435\u043C\u0435 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430"));
  }

  return css(["font-family:", ";font-weight:", ";color:", ";box-sizing:border-box;", ";"], theme.font.fontFamily, theme.componentsTokens.header.fontWeight, theme.font.color, composedEnhancer(_objectSpread({
    theme: theme,
    fontVariant: config.fontVariant,
    pb: config.pb
  }, withPaddingTop && {
    pt: config.pt
  })));
}, display, flexbox, sizes, margins, text, paddings);
export default Header;